import createReducer from "Common/reducerUtils/createReducer";
import filter from "lodash/filter";
import includes from "lodash/includes";
import actionTypes from "./actionTypes";
export const initialState = {
    messages: []
};
export default createReducer(initialState, {
    [actionTypes.ADD_MESSAGE]: (state, { payload }) => ({
        ...state,
        messages: [...state.messages, payload]
    }),
    [actionTypes.CLEAN_MESSAGES]: (state, { payload }) => {
        if (!payload.ids || !payload.ids.length)
            return state;
        return {
            ...state,
            messages: filter(state.messages, item => !includes(payload.ids, item.id))
        };
    }
});
